module.exports = __webpack_public_path__ + "static/kibana-screenshot-d7d22b5d7b6d872ee72e0b0aa1bc41b6.jpg";